import Modal from 'react-modal';
import "./index.css";

export default function ModalChoice({state, setState, customStyle, title, ifOnYesIsFunction, functionOnYes, ifOnNotIsFunction, functionOnNot, view}){
    return (
        <Modal  
            isOpen={state}
            onRequestClose={() => setState(false)}
            className="modal-choice"
            contentLabel="Confirmar"
            ariaHideApp={false}
        >
                <h3>{title}</h3>
                <div className="body-modal__buttons">
                    <button type="button" className="buttonSubmit inputSm" onClick={ifOnYesIsFunction ? functionOnYes : setState(false)} disabled={view}>Sim</button>
                    <button type="button" className="buttonCancel inputSm" onClick={ifOnNotIsFunction ? functionOnNot : setState(false)} disabled={view}>Não</button>
                </div>
        </Modal>
    )
}